{
  "branding": {
    "frontdesk-attribution": "Працює на FrontDesk+",
    "practice-logo": "Логотип {{name}}"
  },
  "validation": {
    "required": "Це поле обов'язкове",
    "invalid-url": "Будь ласка, введіть дійсну URL-адресу",
    "pin-too-short": "PIN повинен містити не менше 4 символів",
    "pin-default-rejected": "Стандартний PIN-код 0000 не дозволяється. Будь ласка, призначте власний PIN-код.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Назад",
    "next": "Далі",
    "cancel": "Скасувати",
    "confirm": "Підтвердити",
    "done": "Готово",
    "retry": "Повторити",
    "clear": "Очистити",
    "close": "Закрити",
    "verifying": "Перевірка...",
    "select": "Вибрати",
    "minutes": "хвилин",
    "clock": "",
    "gender": {
      "M": "Чоловіча",
      "W": "Жіноча",
      "D": "Інша",
      "U": "Невідомо"
    },
    "insurance": {
      "GKV": "Державне",
      "PKV": "Приватне",
      "SELFPAY": "Самооплата"
    },
    "scroll-up": "Прокрутити вгору",
    "scroll-down": "Прокрутити вниз"
  },
  "settings": {
    "device-reset": {
      "title": "Скинути пристрій",
      "description": "Видалити підключення до клініки, налаштування та PIN-код цього пристрою.",
      "confirmation": "Пристрій потрібно буде налаштувати знову. Конфігурація SOL і дані пацієнтів в inSuite залишаться без змін.",
      "cancel": "Скасувати",
      "confirm": "Скинути зараз"
    },
    "title": "Налаштування",
    "save": "Зберегти",
    "save-success": "Налаштування збережено",
    "save-error": "Помилка збереження",
    "load-error": "Помилка завантаження налаштувань",
    "pin": {
      "title": "Потрібен PIN",
      "description": "Будь ласка, введіть PIN для доступу до налаштувань.",
      "error": "Невірний PIN. Будь ласка, спробуйте знову.",
      "backspace": "Видалити останню цифру"
    },
    "connection": {
      "title": "Підключення",
      "description": "Налаштування підключення до сервера Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Назва пристрою",
      "device-name-placeholder": "напр. Ресепшн, каб.1, кіоск",
      "device-name-hint": "Ім'я для ідентифікації на інформаційній панелі Bridge",
      "kim-address": "Адреса KIM (необов'язково)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Тест",
      "success": "Підключення успішне",
      "error": "Помилка підключення",
      "api-unreachable": "DocCirrus API недоступний",
      "status-title": "Статус підключення",
      "status": {
        "api": "API підключено",
        "ti": "Телематична інфраструктура",
        "card-reader": "Доступний пристрій для зчитування карток",
        "medical-card": "Картка клініки (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol-токен (з inSuite)",
      "sol-token-hint": "Скопіюйте з керування Bridge в inSuite. Потрібен для з'єднання.",
      "sol-token-show": "Показати токен",
      "sol-token-hide": "Приховати токен",
      "bridge-unreachable": "Bridge недоступний. Перевірте адресу та порт.",
      "diagnostic-id": "ID діагностики: {{id}}",
      "scan-qr": "Сканувати QR-код",
      "scan-title": "Сканувати QR-код Bridge",
      "scan-manual": "Ввести вручну"
    },
    "terminal": {
      "title": "Пристрій читання карт",
      "description": "Вибір пристрою читання карт для телематичної інфраструктури",
      "select": "Вибрати термінал",
      "select-placeholder": "Виберіть термінал...",
      "loading": "Завантаження терміналів...",
      "none-available": "Термінали недоступні",
      "none-found": "Термінали не знайдено",
      "found": "Знайдено терміналів: {{count}}",
      "connect-hint": "Спочатку підключіться до сервера bridge для завантаження терміналів.",
      "found-count": "Знайдено зчитувачів карток: {{count}}",
      "refresh": "Оновити зчитувачі карток"
    },
    "practice": {
      "title": "Клініка",
      "description": "Інформація про вашу клініку",
      "name": "Назва клініки",
      "name-placeholder": "наприклад, Доктор Іван Іванов",
      "welcome-message": "Привітальне повідомлення",
      "welcome-placeholder": "напр. Ласкаво просимо до нашої клініки",
      "scheduler-available": "Увімкнути планувальник",
      "scheduler-available-description": "Дозвольте пацієнтам записуватися на прийом через термінал самообслуговування",
      "prescription-available": "Увімкнути службу рецептів",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Залиште порожнім — привітання буде мовою пацієнта. Ваш власний текст показується без змін усіма мовами."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Збережено для всіх пристроїв: {{value}}",
      "never-saved-default": "Типове налаштування, ще не змінювалося."
    },
    "anamnesis": {
      "title": "Цифрова історія хвороби",
      "description": "Показує посилання та QR code на ваш постачальник історії хвороби після реєстрації.",
      "enabled": "Показати посилання на історію хвороби після реєстрації",
      "enabled-description": "Показує посилання та QR code на ваш постачальник історії хвороби після завершеної реєстрації, наприклад Nelly.",
      "url": "Посилання на постачальника історії хвороби",
      "url-hint": "Посилання є статичним і однаковим для всіх пацієнтів.",
      "preview-label": "Попередній перегляд екрана завершення",
      "preview-note": "Посилання є статичним і однаковим для всіх пацієнтів.",
      "url-first": "Щоб увімкнути, спершу введіть дійсне посилання."
    },
    "appearance": {
      "title": "Зовнішній вигляд",
      "description": "Налаштування користувацького інтерфейсу",
      "language": "Мова",
      "default-kiosk-language": "Мова пацієнта за замовчуванням",
      "default-kiosk-language-hint": "Мова, якою починаються нові сесії кіоску для пацієнтів.",
      "voice-over-volume": "Гучність голосу за кадром",
      "voice-over-hint": "Керує гучністю голосового асистента для забезпечення доступності.",
      "language-first": "Показувати вибір мови на початку сеансу"
    },
    "security": {
      "title": "Безпека",
      "description": "PIN для доступу до налаштувань",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Керування кіоском",
    "nav": {
      "general": "Загальні",
      "flows": "Функції",
      "anamnese": "Цифровий анамнез",
      "device": "Пристрій і з'єднання"
    },
    "flows": {
      "title": "Функції на терміналі"
    },
    "language": {
      "title": "Мова та озвучення",
      "description": "Мова та читання вголос для пацієнтів на цьому пристрої."
    }
  },
  "self-service": {
    "title": "Самообслуговування",
    "step-progress": "Крок {{current}} / {{total}}",
    "flows": {
      "checkin": "Реєстрація",
      "scheduler": "Записатися на прийом",
      "prescription": "Приписи",
      "locations": "Карта розташування",
      "emergency": "Екстрена допомога"
    },
    "audio-guide": {
      "on": "Звук увімкнено",
      "off": "Звук вимкнено",
      "replay": "Повторити інструкцію",
      "replay-unavailable": "Немає голосової інструкції для повтору"
    },
    "language-selector": {
      "title": "Виберіть мову",
      "description": "Будь ласка, виберіть бажану мову"
    },
    "settings": "Налаштування",
    "start": {
      "welcome": "Ласкаво просимо",
      "subtitle": "Будь ласка, виберіть опцію",
      "check-in-label": "Основний шлях",
      "check-in-cta": "Реєстрація",
      "check-in-description": "У вас вже є запис? Зареєструйтеся тут.",
      "check-in-hint": "Приготуйте картку",
      "scheduler-label": "Новий",
      "scheduler-cta": "Записатися на прийом",
      "scheduler-description": "Запишіться на новий прийом.",
      "location-plan": "Карта розташування",
      "location-plan-description": "Знайдіть шлях до процедурного кабінету.",
      "prescription-label": "Рецепт",
      "prescription-cta": "Рецепти та замовлення",
      "prescription-description": "Переглянути рецепти або замовити доповнення.",
      "emergency-cta": "Локальний аварійний сигнал",
      "emergency-description": "Лунає лише на цьому пристрої й не викликає допомогу.",
      "tap-to-start": "Натисніть, щоб почати"
    },
    "offline": {
      "banner-title": "Реєстрація тимчасово недоступна",
      "banner-message": "Будь ласка, зверніться до персоналу стійки реєстрації, щоб отримати допомогу.",
      "emergency-available": "Локальний сигнал залишається доступним. Він не викликає допомогу.",
      "flow-disabled": "Тимчасово недоступний"
    },
    "readability": {
      "toggle-label": "Режим читання",
      "on": "Режим читання",
      "off": "Режим читання"
    },
    "reset-overlay": {
      "timeout-title": "Сеанс завершено",
      "timeout-subtitle": "Ваш час минув. Ваші дані в безпеці.",
      "offline-title": "З'єднання втрачено",
      "offline-subtitle": "З'єднання було перервано. Будь ласка, поговоріть з персоналом стійки реєстрації.",
      "interruption-title": "Сеанс завершено",
      "interruption-subtitle": "Ваш сеанс благополучно завершено.",
      "completion-title": "Дякую!",
      "completion-subtitle": "Ваш запит успішно виконано.",
      "reassurance": "Ваші особисті дані не зберігаються на цьому пристрої.",
      "auto-dismiss": "Повернення до початку через {{seconds}} секунд...",
      "dismiss": "Перейти до початку"
    },
    "timed-terminal": {
      "countdown": "Автоматичне повернення через {{seconds}} секунд",
      "countdown-outcome": "Цей термінал автоматично повернеться до початкового екрана.",
      "more-time": "Більше часу",
      "extended": "Час подовжено"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Ці запитання недоступні вашою мовою. Виберіть одну із запропонованих мов або зверніться до реєстратури.",
        "alternatives": "Альтернативні записи",
        "loading": "Завантаження запитань…",
        "reception-fallback": "Будь ласка, зверніться на рецепцію.",
        "error-title": "Не вдалося завантажити запитання",
        "language-unavailable-lead": "Ці запитання недоступні вашою мовою.",
        "language-unavailable-title": "Будь ласка, виберіть одну з цих мов",
        "language-unavailable-body": "Або попросіть допомоги на рецепції."
      },
      "start": {
        "title": "Записатися на прийом",
        "subtitle": "Запишіться на зручний прийом за кілька кроків",
        "welcome": "Ласкаво просимо до запису на прийом",
        "description": "Ми проведемо вас через процес запису",
        "cta": "Записатися зараз"
      },
      "patient-id": {
        "title": "Ідентифікація",
        "subtitle": "Будь ласка, представтеся",
        "mode-card": "З карткою",
        "mode-search": "Пошук",
        "mode-create": "Створити новий",
        "insert-card": "Будь ласка, вставте вашу страхову картку",
        "reading-card": "Читання картки...",
        "simulate-card": "Симулювати картку",
        "multiple-matches": "Знайдено кілька пацієнтів. Використовуються дані картки.",
        "search-placeholder": "Ім'я або номер страховки...",
        "searching": "Пошук...",
        "no-results": "Результати не знайдено",
        "first-name": "Ім'я",
        "last-name": "Прізвище",
        "dob": "Дата народження",
        "insurance": "Страховка",
        "continue": "Продовжити",
        "creating": "Створення пацієнта...",
        "patient-created": "Пацієнт створено успішно!",
        "create-error": "Не вдалося створити пацієнта."
      },
      "appointment-type": {
        "title": "Виберіть тип прийому",
        "subtitle": "Будь ласка, виберіть причину вашого візиту",
        "loading": "Завантаження типів прийому...",
        "no-types": "Типи прийому недоступні",
        "error": "Не вдалося завантажити типи прийому. Будь ласка, спробуйте знову.",
        "no-bookable": "Ці типи прийомів зараз не можна забронювати через кіоск. Зверніться до реєстратури або запишіться телефоном.",
        "disabled-default": "Будь ласка, запишіться на цей прийом безпосередньо в реєстратурі або телефоном.",
        "disabled-footer": "Тільки через реєстратуру/телефон",
        "lead": "Який прийом ви хочете забронювати?",
        "duration": "бл. {{minutes}} хвилин",
        "empty-title": "Зараз тут не можна записатися на прийом",
        "none-bookable-title": "Ці прийоми тут забронювати не можна",
        "none-bookable-body": "Будь ласка, запитайте на рецепції або зателефонуйте нам."
      },
      "types": {
        "general": "Загальна консультація",
        "general-desc": "Для загальних скарг і питань",
        "checkup": "Профілактичний огляд",
        "checkup-desc": "Регулярні медичні огляди",
        "vaccination": "Вакцинація",
        "vaccination-desc": "Запис на вакцинацію",
        "followup": "Повторний прийом",
        "followup-desc": "Контрольний прийом",
        "prescription": "Рецепт",
        "prescription-desc": "Отримання рецепта"
      },
      "slot-selection": {
        "title": "Виберіть прийом",
        "subtitle": "Будь ласка, виберіть доступний прийом",
        "loading": "Завантаження доступних прийомів...",
        "no-slots": "Немає доступних прийомів",
        "no-appointment-type": "Тип прийому не вибрано",
        "error": "Не вдалося завантажити доступні слоти. Будь ласка, спробуйте знову.",
        "quick-select": "Наступні доступні прийоми:",
        "select-date": "Або виберіть дату:",
        "times-for": "{{date}}",
        "available": "Доступно",
        "unavailable": "Немає слотів",
        "slots": "слоти",
        "select-time-hint": "Натисніть на час, щоб записатися",
        "week-short": "Тиж",
        "weekday-mon": "Пн",
        "weekday-tue": "Вт",
        "weekday-wed": "Ср",
        "weekday-thu": "Чт",
        "weekday-fri": "Пт",
        "weekday-sat": "Сб",
        "weekday-sun": "Нд",
        "period-morning": "Ранок",
        "period-midday": "Полудень",
        "period-afternoon": "День",
        "period-evening": "Вечір",
        "period-morning-short": "Ранок",
        "period-midday-short": "Полуд.",
        "period-afternoon-short": "День",
        "period-evening-short": "Вечір",
        "period-dots-legend": "Доступність часу",
        "filter-hint": "Фільтр за бажаним часом:",
        "or-choose-below": "або виберіть нижче",
        "no-slots-period": "Немає слотів",
        "show-all": "Показати все",
        "free": "безкоштовно",
        "your-selection": "Ваш вибір",
        "oclock": "год",
        "choose-slot": "Виберіть слот",
        "choose-day": "Виберіть день",
        "choose-day-first": "Спочатку виберіть день",
        "times-heading": "Вільний час {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Немає вільних прийомів: {{month}}",
        "empty-body": "Перегляньте наступний місяць або запитайте на рецепції — ми охоче допоможемо.",
        "next-month": "Наступний місяць",
        "previous-month": "Попередній місяць"
      },
      "confirmation": {
        "patient-responses": "Ваші відповіді",
        "review-loading": "Перевірка підсумку…",
        "review-unavailable": "Підсумок недоступний. Будь ласка, спробуйте ще раз або запитайте на рецепції.",
        "check-booking": "Перевірити запис",
        "title": "Підтвердіть прийом",
        "subtitle": "Будь ласка, перевірте ваш запис",
        "patient": "Пацієнт",
        "datetime": "Дата і час",
        "booking": "Запис...",
        "confirm": "Записатися",
        "heading": "Це виглядає правильно?",
        "lead": "Будь ласка, підтвердьте вашу зустріч.",
        "appointment": "Призначення",
        "insured-via": "Застрахований через",
        "description-label": "Примітки для клініки (необов’язково)",
        "description-hint": "Повідомте нам, якщо під час запису або реєстрації потрібно щось врахувати.",
        "description-placeholder": "наприклад, обмежена рухливість, супровід, важливі примітки",
        "description-too-long": "Будь ласка, скоротіть примітку до 500 символів.",
        "summary": "Підсумок",
        "change": "Змінити",
        "book-binding": "Запис на зустріч",
        "cancel": "Скасувати",
        "type-label": "Вид прийому",
        "datetime-value": "{{date}} о {{time}}",
        "name-label": "Ім'я",
        "insurance-label": "Страхування",
        "insurance-GKV": "Обов'язкове медичне страхування",
        "insurance-PKV": "Приватне медичне страхування",
        "insurance-SELFPAY": "Самостійна оплата",
        "change-time": "Змінити прийом",
        "description-free-text": "Інші примітки (необов'язково)",
        "note-wheelchair": "Я користуюся інвалідним візком",
        "note-companion": "Я прийду із супроводом",
        "note-interpreter": "Мені потрібен перекладач"
      },
      "done": {
        "title": "Прийом записано!",
        "label": "Заброньовано",
        "subtitle": "Ваш прийом успішно записано.",
        "date": "Дата",
        "time": "Час",
        "booking-id": "Номер запису",
        "qr-hint": "Додати до календаря",
        "qr-description": "Відскануйте цей QR-код камерою смартфона, щоб додати прийом до календаря",
        "auto-redirect": "Ви будете перенаправлені на початкову сторінку найближчим часом...",
        "auto-redirect-countdown": "Повернення до початку через {{seconds}} секунд...",
        "back-to-start": "Повернутися до початку",
        "print-button": "Роздрукувати талон на прийом",
        "print-preparing": "Підготовка вікна друку…",
        "print-error": "Не вдалося відкрити талон на прийом. Спробуйте ще раз або зверніться по допомогу до реєстратури.",
        "print-returned": "Системне вікно друку закрито. За потреби можна запросити ще одну копію.",
        "print-title": "Ваш прийом",
        "print-location": "Місце",
        "print-map-hint": "Відкрити місце на телефоні",
        "print-error-v2": "Не вдалося відкрити талон на прийом. Будь ласка, спробуйте ще раз або запитайте на рецепції."
      },
      "error": {
        "assistance-info": "Не вдалося підтвердити запис. Можливо, прийом уже заброньовано. Будь ласка, запитайте на рецепції.",
        "pending-title": "Запис не підтверджено",
        "pending-info": "Не вдалося підтвердити запис. Можливо, прийом уже заброньовано. Будь ласка, перевірте ще раз або запитайте на рецепції.",
        "title": "Помилка запису",
        "subtitle": "Не вдалося записати прийом.",
        "info": "Будь ласка, спробуйте ще раз або запитайте на рецепції."
      },
      "phase": {
        "identify": "Реєстрація",
        "choose": "Вибір часу",
        "confirm": "Підтвердження"
      }
    },
    "prescription": {
      "start": {
        "title": "Рецепти та замовлення",
        "subtitle": "Вставте свою картку страхування, щоб переглянути рецепти або замовити доповнення.",
        "button": "Вставте картку"
      },
      "card-check": {
        "loading": "Завантаження пристрою для читання карт...",
        "no-terminal": "Не налаштовано зчитувач карток",
        "no-terminal-hint": "Будь ласка, зверніться до персоналу по допомогу.",
        "insert-card": "Вставте картку",
        "insert-card-hint": "Вставте картку страхування в пристрій для читання карток.",
        "card-detected": "Виявлено картку",
        "reading": "Картка для читання...",
        "reading-hint": "Зачекайте хвилинку.",
        "error": "Помилка читання картки",
        "retry": "Спробуйте ще раз",
        "manual-lookup": "Продовжити без картки",
        "load-error": "Не вдалося завантажити пристрій для читання карток",
        "read-error": "Не вдалося прочитати картку"
      },
      "patient-selection": {
        "title": "Виберіть пацієнта",
        "subtitle": "Було виявлено кілька пацієнтів. Виберіть своє ім'я.",
        "try-again": "Спробуйте ще раз",
        "try-again-hint": "Вставте картку знову"
      },
      "list": {
        "title": "Ваші рецепти",
        "for-patient": "Рецепти для {{name}}",
        "loading": "Завантаження рецептів...",
        "error-title": "Помилка завантаження",
        "fetch-error": "Не вдалося завантажити рецепти",
        "back-home": "Назад до початку",
        "done": "Виконано"
      },
      "detail": {
        "prescription-info": "Інформація про рецепт",
        "date": "Дата",
        "prescriber": "Приписувач",
        "comment": "Примітка",
        "medications": "Ліки",
        "form": "Форма",
        "pack-size": "Розмір упаковки",
        "manufacturer": "Виробник",
        "loading": "Завантаження рецепта...",
        "fetch-error": "Не вдалося завантажити відомості про рецепт",
        "back-to-list": "Назад до списку",
        "print": "Друк"
      },
      "types": {
        "public": "Державний рецепт",
        "private": "Приватний рецепт",
        "long-term": "Довгострокова давність",
        "btm": "Наркотичні рецепти",
        "g": "Зелений рецепт",
        "t": "Т-рецепт"
      },
      "no-patient": {
        "title": "Пацієнта не знайдено",
        "subtitle": "На жаль, для цієї картки не знайдено жодного пацієнта. Будь ласка, зверніться до персоналу по допомогу.",
        "try-again": "Спробуйте знову",
        "back-home": "Назад до початку",
        "title-v2": "Відповідних даних не знайдено",
        "subtitle-v2": "Не вдалося вас знайти. Будь ласка, спробуйте ще раз або запитайте на рецепції."
      },
      "done": {
        "title": "Дякую",
        "subtitle": "Ви можете сісти зараз. Якщо у вас виникли запитання, зв'яжіться з персоналом.",
        "no-prescriptions-title": "Немає рецептів у файлі",
        "no-prescriptions-subtitle": "Нам не вдалося знайти жодного активного рецепта для вас. Якщо ви очікуєте його, зв'яжіться з персоналом стійки реєстрації.",
        "error-title": "Сталася помилка",
        "error-subtitle": "Будь ласка, зверніться до персоналу для отримання додаткової допомоги.",
        "auto-redirect": "Автоматичне перенаправлення через {{seconds}} секунд",
        "finish": "Повернутися до початку"
      },
      "hub": {
        "title": "Ваші рецепти",
        "for-patient": "Рецепти для {{name}}",
        "loading": "Завантаження рецептів...",
        "error-title": "Помилка завантаження",
        "fetch-error": "Не вдалося завантажити рецепти",
        "back-home": "Назад до початку",
        "done": "Виконано",
        "order-button": "Замовити рецепт",
        "existing-prescriptions": "Ваші поточні рецепти",
        "no-prescriptions": "Активних рецептів не знайдено."
      },
      "patient-lookup": {
        "title": "Знайти пацієнта",
        "subtitle": "Введіть своє ім'я та дату народження.",
        "last-name": "Прізвище",
        "first-name": "Ім'я",
        "date-of-birth": "Дата народження",
        "lastname": "Прізвище",
        "lastname-placeholder": "Ваше прізвище",
        "firstname": "Ім'я",
        "firstname-placeholder": "Ваше ім'я",
        "dob": "Дата народження",
        "search": "Пошук",
        "searching": "Пошук...",
        "search-error": "Помилка пошуку: {{message}}",
        "no-match": "Пацієнта не знайдено. Будь ласка, перевірте свою інформацію.",
        "error": "Помилка пошуку. Спробуйте ще раз.",
        "found": "Пацієнта знайдено",
        "confirm": "Підтвердити",
        "ambiguous": "Кілька збігів",
        "ambiguous-hint-firstname": "Також введіть своє ім'я, щоб уточнити пошук.",
        "ambiguous-hint-additional": "Будь ласка, перевірте свою інформацію або зв'яжіться зі співробітниками.",
        "not-found": "Пацієнта не знайдено",
        "not-found-hint": "Не вдалося знайти жодного пацієнта з цими деталями.",
        "not-found-action": "Спробуйте ще раз"
      },
      "manual-identification": {
        "unverified": "Вашу особу не підтверджено за допомогою картки медичного страхування. Практика перевірить ваші дані та запит перед обробкою."
      },
      "medication-selection": {
        "title": "Запит на рецепт",
        "subtitle": "Клініка розглядає ваш запит. Після схвалення eRx буде готовий у вашому застосунку e-prescription.",
        "back": "Назад",
        "submit": "Продовжте перегляд",
        "reason-title": "Навіщо вам рецепт?",
        "reason-hint": "Допомагає клініці оцінити ваш запит.",
        "reason-validation": "Виберіть причину.",
        "reason-schmerzen": "Біль",
        "reason-entzuendung": "Запалення",
        "reason-nachsorge": "Процедура / після операції",
        "reason-allergie": "Алергічна реакція /",
        "reason-chronisch": "Хронічний стан",
        "reason-anderes": "Щось інше",
        "medications-title": "Які ліки?",
        "request-hint": "Опишіть, що вам потрібно, або назвіть попередній рецепт, який ви хочете продовжити.",
        "request-placeholder": "напр. Ібупрофен 600 мг, як і минулого разу",
        "request-validation": "Будь ласка, опишіть, які ліки вам потрібні.",
        "history-title": "Попередні приписи",
        "history-hint": "Додайте запис, щоб попередньо заповнити запит.",
        "history-loading": "Завантаження попередніх рецептів...",
        "history-error": "Не вдалося завантажити попередні рецепти.",
        "history-add": "Додати",
        "history-added": "Додано",
        "history-date": "Останній: {{date}}",
        "history-request-line": "Поновити: {{medicationName}}",
        "urgency-title": "Наскільки це терміново?",
        "urgency-hint": "Допомагає клініці визначити пріоритет.",
        "urgency-soon": "Терміново",
        "urgency-soon-meta": "Якомога швидше",
        "urgency-tomorrow": "Скоро",
        "urgency-tomorrow-meta": "У найближчі кілька днів",
        "urgency-week": "Цього тижня",
        "urgency-week-meta": "Без тиску часу",
        "lead": "Практика розгляне ваш запит. Після схвалення електронний рецепт буде доступний у застосунку для електронних рецептів або на вашій страховій картці.",
        "history-hint-v2": "Натисніть на попередній рецепт, щоб додати його.",
        "history-retry": "Завантажити знову"
      },
      "request-review": {
        "title": "Наказ про перегляд",
        "subtitle": "Будь ласка, перегляньте свій запит на рецепт.",
        "request-label": "Запитані ліки",
        "selected-medications": "Вибрані ліки",
        "free-text-medications": "Додаткові ліки",
        "freetext-label": "Інше",
        "quarterly-warning": "Вашу страхову картку не було зчитано в цьому кварталі. Клініка може зв'язатися з вами.",
        "egk-warning": "Вашу страхову картку не було зчитано в цьому кварталі. Клініка може зв'язатися з вами.",
        "submit": "Подати",
        "submitting": "Подання...",
        "submit-error": "Не вдалося надіслати запит. Спробуйте ще раз.",
        "back": "Назад",
        "reason-label": "Розум",
        "urgency-label": "Терміновість",
        "completion-email-choice": "Я хочу отримати електронного листа, коли практика опрацює мій запит.",
        "completion-email-label": "Адреса електронної пошти",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "Лише для цього одноразового повідомлення. Адреса не зберігається в основних даних.",
        "completion-email-invalid": "Введіть дійсну адресу електронної пошти.",
        "egk-proof-required": "Запит на рецепт доступний лише після успішного зчитування страхової картки. Зверніться до персоналу.",
        "title-v2": "Перевірити запит",
        "completion-email-hint-v2": "Адреса використовується лише для цього одного повідомлення."
      },
      "confirmation": {
        "title": "Запит надіслано",
        "subtitle": "Ваш запит на рецепт успішно подано.",
        "success-title": "Запит надіслано",
        "success-subtitle": "Ваш запит на рецепт успішно подано.",
        "estimated-time": "Ваш рецепт буде готовий приблизно через {{time}}.",
        "info": "Ви можете отримати рецепт в аптеці за допомогою вашої страхової картки або програми eRezept.",
        "auto-redirect": "Автоматичне перенаправлення через {{seconds}} секунд",
        "back-to-start": "Назад до початку",
        "handling-label": "Handled by the practice",
        "next-steps": "Практика розгляне ваш запит. Після схвалення ви зможете отримати ліки за електронним рецептом в аптеці зі страховою карткою або через застосунок для електронних рецептів."
      },
      "phase": {
        "identify": "Реєстрація",
        "request": "Запит",
        "review": "Перевірка"
      }
    },
    "check-in": {
      "flow-label": "Реєстрація",
      "has-appointment": {
        "eyebrow": "Призначення",
        "title": "У вас є запис?",
        "subtitle": "Будь ласка, виберіть опцію",
        "yes-label": "Так",
        "yes": "Так, у мене є запис",
        "yes-description": "Я хочу зареєструватися на прийом.",
        "yes-hint": "Найшвидший шлях",
        "unsure-label": "Можливо",
        "unsure": "Я не впевнений",
        "unsure-description": "Ми перевіримо це для вас.",
        "unsure-hint": "Ми вас розшукаємо",
        "no-label": "№",
        "no": "Ні, без запису",
        "no-description": "У мене немає запису.",
        "no-hint": "Вхід"
      },
      "card-check": {
        "eyebrow": "Страхова картка",
        "title": "Прочитати страхову картку",
        "subtitle": "Будь ласка, вставте страхову картку в пристрій читання",
        "insert-title": "Вставте страхову картку в зчитувач.",
        "insert-detail": "Ми читаємо ваші дані автоматично — вам не потрібно нічого робити.",
        "other-ways": "Інші способи",
        "no-card-hint": "Якщо у вас зараз немає вашої картки.",
        "pkv-hint": "Використовуйте QR code зі своїм додатком страхування.",
        "loading": "Завантаження налаштувань...",
        "no-terminal": "Пристрій читання карт не налаштовано. Будь ласка, зверніться до персоналу.",
        "checking": "Перевірка карток...",
        "insert-prompt": "Будь ласка, вставте картку...",
        "card-detected": "Картку виявлено! Готово до читання.",
        "read-card": "Прочитати картку",
        "simulate-insert": "Симулювати картку",
        "reading": "Читання картки...",
        "error": "Не вдалося прочитати картку. Будь ласка, спробуйте знову.",
        "read-error": "Не вдалося прочитати дані картки. Будь ласка, спробуйте знову.",
        "settings-error": "Не вдалося завантажити налаштування. Будь ласка, спробуйте знову.",
        "no-card-prompt": "Немає картки з собою?",
        "no-card-action": "Ручний пошук",
        "connection-warning": "Проблеми з підключенням до пристрою для читання карток. Будь ласка, зачекайте...",
        "pkv-prompt": "Приватне страхування? Online Check-in",
        "pkv-instruction": "Відскануйте цей QR code за допомогою програми приватного медичного страхування, щоб передати свої дані в цифровому вигляді.",
        "pkv-continue": "Перейти до ручної реєстрації",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Спробуйте ще раз або зареєструйтеся без картки. На рецепції вам охоче допоможуть.",
        "title-pkv": "Реєстрація через застосунок",
        "title-reading": "Ваша картка зчитується …",
        "title-unreadable": "Не вдалося прочитати картку",
        "title-no-terminal": "Реєстрація без картки",
        "no-terminal-body": "Зчитувач карток зараз недоступний. Зареєструйтеся без картки або зверніться на рецепцію.",
        "reading-detail": "Будь ласка, не виймайте картку. Це займе лише мить.",
        "other-ways-title": "Інші можливості",
        "no-card-title": "Зареєструватися без картки",
        "pkv-prompt-title": "Приватне страхування?",
        "pkv-prompt-hint": "Реєстрація через застосунок вашого приватного медичного страхування",
        "pkv-close": "Усе ж із карткою",
        "pkv-instruction-app": "Відкрийте застосунок свого приватного медичного страхування та відскануйте цей код. Ваші дані надійдуть прямо до нас."
      },
      "patient-selection": {
        "title": "Виберіть пацієнта",
        "subtitle": "Знайдено кілька пацієнтів. Будь ласка, виберіть себе.",
        "firstname-label": "Ваше ім'я",
        "firstname-placeholder": "Введіть ім'я...",
        "confirm-button": "Підтвердити",
        "no-match": "Відповідного пацієнта не знайдено. Будь ласка, зверніться до стійки реєстрації за допомогою.",
        "still-ambiguous": "Залишилося кілька збігів. Будь ласка, зверніться до стійки реєстрації за допомогою.",
        "select-error": "Не вдалося ідентифікувати пацієнта. Спробуйте ще раз.",
        "staff-assist": "Ідіть на прийом",
        "title-v2": "Коротке запитання",
        "subtitle-v2": "Для безпеки введіть своє ім'я.",
        "no-match-v2": "Ми не знайшли вас із цим ім'ям. Перевірте написання або зверніться на рецепцію.",
        "still-ambiguous-v2": "Нам ще не вдалося однозначно знайти вас. Зверніться на рецепцію.",
        "select-error-v2": "На жаль, не вдалося. Спробуйте ще раз."
      },
      "card-checkin": {
        "title": "Підтвердіть реєстрацію",
        "subtitle": "Ваші дані успішно прочитано.",
        "confirm": "Підтвердити реєстрацію"
      },
      "register-from-card": {
        "title": "Нова реєстрація",
        "subtitle": "Вас ще немає в нашій системі. Хочете зареєструватися?",
        "card-data": "Дані картки",
        "create": "Зареєструватися",
        "create-error": "Помилка реєстрації. Спробуйте ще раз або зверніться по допомогу до персоналу.",
        "staff-assist": "Виклик персоналу",
        "no-card-data-title": "Немає даних картки",
        "no-card-data": "Не вдається прочитати дані з вашої картки.",
        "insurance-verified": "Страхування перевірено: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Ваші дані з картки",
        "subtitle-v2": "Перевірте свої дані. Якщо щось неправильно, торкніться «Змінити».",
        "create-v2": "Підтвердити дані",
        "create-error-v2": "Реєстрація, на жаль, не вдалася. Спробуйте ще раз або зверніться на рецепцію.",
        "insurer-missing-v2": "На вашій картці немає даних про лікарняну касу. Зверніться на рецепцію.",
        "edit": "Змінити",
        "name": "Ім'я",
        "insurer": "Лікарняна каса"
      },
      "patient-lookup": {
        "title": "Пошук пацієнта",
        "subtitle": "Будь ласка, введіть ваше ім'я або номер страховки.",
        "lastname": "Прізвище",
        "lastname-placeholder": "Ваше прізвище",
        "dob": "Дата народження",
        "firstname": "Ім'я",
        "firstname-placeholder": "Ваше ім'я",
        "search": "Пошук",
        "searching": "Пошук...",
        "search-placeholder": "Ім'я або номер страховки...",
        "results-placeholder": "Результати пошуку з'являться тут",
        "found": "Пацієнта знайдено!",
        "confirm-identity": "Будь ласка, підтвердьте, що ви є показаним пацієнтом.",
        "confirm-button": "Це я",
        "ambiguous-firstname": "Було знайдено кілька пацієнтів. Будь ласка, введіть своє ім'я.",
        "ambiguous-additional": "Було виявлено кілька пацієнтів. Будь ласка, зв'яжіться з персоналом.",
        "disambiguation-hint": "Це допомагає нам чітко ідентифікувати вас.",
        "not-found": "Не знайдено жодного пацієнта з цими деталями.",
        "error": "Помилка пошуку: {{message}}",
        "staff-assist": "Виклик персоналу",
        "not-found-prompt": "Не знайдено?",
        "register-new": "Зареєструватися",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Реєстрація без картки",
        "subtitle-firstname": "Введіть також своє ім'я.",
        "ambiguous-firstname-v2": "Є кілька людей із цим прізвищем. Введіть також своє ім'я.",
        "search-again": "Шукати знову",
        "found-v2": "Ми вас знайшли",
        "found-confirm": "Підтвердьте кнопкою «Це я».",
        "not-found-title": "Ми вас не знайшли",
        "not-found-check": "Перевірте написання та дату народження. На рецепції вам охоче допоможуть.",
        "not-found-reception": "Перевірте написання та дату народження або зверніться на рецепцію.",
        "ambiguous-additional-v2": "Нам не вдалося однозначно знайти вас. Зверніться на рецепцію.",
        "error-v2": "Пошук зараз не вдався. Спробуйте ще раз."
      },
      "checking-in": {
        "title": "Хвилинку — ми реєструємо вас.",
        "subtitle": "Ми додаємо вас до черги лікування та повідомляємо команду.",
        "step-insurance": "Страхування перевірено",
        "step-appointment": "Призначення підтверджено",
        "step-waitlist": "Додавання до списку очікування",
        "error": "Помилка реєстрації. Спробуйте ще раз.",
        "continue": "Все одно продовжити",
        "title-v2": "Хвилинку, будь ласка",
        "loading": "Реєструємо вас …",
        "subtitle-v2": "Записуємо вас до списку очікування та повідомляємо команду.",
        "error-title": "На жаль, не вдалося",
        "error-v2": "Не вдалося завершити вашу реєстрацію.",
        "error-body": "Спробуйте ще раз. Якщо знову не вийде, вам допоможе рецепція."
      },
      "appointment-selection": {
        "title": "Виберіть зустріч",
        "subtitle": "Сьогодні у вас кілька зустрічей. Виберіть один.",
        "checking-in": "Реєстрація...",
        "time": "{{time}}",
        "error-v2": "Реєстрація на цей прийом не вдалася. Спробуйте ще раз або зверніться на рецепцію."
      },
      "no-appointment": {
        "title": "Зустрічі не знайдено",
        "subtitle": "Ми не змогли знайти для вас зустріч сьогодні. Будь ласка, запишіться на регулярний прийом.",
        "book-appointment": "Запис на зустріч",
        "book-appointment-description": "Забронюйте нову зустріч через звичайний планувальник.",
        "staff-assist": "Виклик персоналу",
        "staff-assist-description": "Мені потрібна допомога.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Сьогодні ми не знайшли для вас запису.",
        "book-v2": "Записатися на новий прийом",
        "book-v2-description": "Оберіть вільний час.",
        "have-appointment": "У мене є запис",
        "have-appointment-description": "На рецепції вам охоче допоможуть.",
        "unavailable-title": "Записатися на прийом можна на рецепції",
        "subtitle-unavailable": "Сьогодні ми не знайшли для вас запису. Зверніться на рецепцію."
      },
      "staff-assist": {
        "title": "Персонал повідомлено",
        "subtitle": "Співробітник найближчим часом допоможе вам.",
        "message": "Будь ласка, зачекайте тут. Співробітник незабаром прибуде до вас.",
        "start-over": "Повернутися до початку",
        "auto-redirect": "Повернення до початку через {{seconds}} секунд..."
      },
      "eeb-prompt": {
        "title": "Перевірити страховку",
        "title-failed": "Перевірка не вдалася",
        "subtitle": "Як ви хочете перевірити страховку?",
        "subtitle-failed": "Відскануйте QR-код за допомогою додатка страхової компанії для запиту перевірки.",
        "verify-card": "Перевірити електронно",
        "verify-card-description": "Відправити запит вашій страховій компанії.",
        "select-insurer": "Вибрати страховика",
        "select-insurer-description": "Ручний вибір вашого страховика.",
        "skip": "Пропустити",
        "eyebrow-chip": "Альтернатива",
        "eyebrow": "Реєстрація · підтвердження страхування (eEB)",
        "recommended": "Рекомендовано",
        "qr-title": "Сканування за допомогою програми страхування",
        "qr-description": "Відкрийте програму медичного страхування та відскануйте код — eEB буде надіслано безпосередньо нам.",
        "qr-address-label": "Надіслати",
        "title-app": "Підтвердження через застосунок",
        "subtitle-app": "Ваша лікарняна каса може надіслати нам підтвердження напряму. Коли закінчите, торкніться «Далі»."
      },
      "quarterly-check": {
        "title": "Перевірка страховки",
        "checking": "Ми перевіряємо вашу поточну страхову перевірку...",
        "error": "Перевірка не може бути виконана.",
        "title-v2": "Ваше страхування",
        "checking-v2": "Перевіряємо ваше страхування – хвилинку, будь ласка.",
        "error-body": "Вашу реєстрацію завершено. Питання страхування рецепція вирішить разом із вами."
      },
      "insurer-prefilled": {
        "title": "Ваша медична страховка",
        "subtitle": "Будь ласка, підтвердіть вашу страховку на цей квартал.",
        "your-insurance": "Ваша страховка",
        "last-read": "Остання перевірка {{date}}",
        "quarterly-notice": "Для виставлення рахунку нам потрібне поточне підтвердження страховки на цей квартал.",
        "confirm-button": "Так, це моя страховка",
        "change-button": "У мене інша страховка",
        "contact-title": "Запит електронного підтвердження покриття",
        "contact-description": "Зателефонуйте до страхової компанії та вимагайте електронне підтвердження покриття для:",
        "contact-patient": "Пацієнт",
        "contact-kim-address": "KIM-адреса клініки",
        "contact-phone": "Тел",
        "question": "Це ваша лікарняна каса?",
        "quarterly-notice-v2": "Раз на квартал нам потрібне підтвердження від вашої лікарняної каси."
      },
      "insurer-search": {
        "title": "Виберіть медичну страховку",
        "subtitle": "Будь ласка, знайдіть і виберіть вашу державну медичну страховку.",
        "placeholder": "Пошук страховки...",
        "hint": "Введіть не менше 2 символів для пошуку.",
        "no-results": "Страховку не знайдено.",
        "no-results-hint": "Перевірте правопис або спробуйте інший пошук.",
        "label": "Назва вашої лікарняної каси",
        "search-error-v2": "Пошук зараз не вдався. Спробуйте ще раз.",
        "app-alternative": "Краще через застосунок лікарняної каси?"
      },
      "insurer-contact": {
        "title": "Вимагайте підтвердження страхування",
        "subtitle": "Виберіть один із наведених нижче варіантів.",
        "or": "або",
        "option-eeb-title": "Запит в електронному вигляді",
        "option-eeb-description": "Якщо є передбачений законом винятковий випадок, ви можете після своєї згоди передати запит команді практики.",
        "option-qr-title": "Сканування за допомогою програми",
        "option-qr-description": "Скануйте QR code за допомогою програми страхування.",
        "option-call-title": "Зателефонуйте самі",
        "option-call-description": "Зателефонуйте до страхової компанії та попросіть eEB для цієї клініки:",
        "phone": "Тел",
        "phone-not-available": "Номер телефону на вашій страховій картці",
        "patient-name": "Пацієнт",
        "practice-kim": "KIM-адреса клініки",
        "help-notice": "Якщо у вас виникли проблеми, зверніться до стійки реєстрації.",
        "submit-eeb-button": "Запит зараз",
        "contacted-button": "Я подзвонив",
        "contacted-button-countdown": "Час для вашого дзвінка ({{seconds}}s)",
        "go-to-counter-button": "Ідіть на прийом",
        "qr-continue-button": "я сканував",
        "qr-continue-button-countdown": "Час сканування ({{seconds}}s)",
        "title-v2": "Підтвердження від вашої лікарняної каси",
        "subtitle-v2": "Найпростіше через застосунок вашої лікарняної каси.",
        "subtitle-no-app": "Оберіть, як лікарняна каса має надіслати нам підтвердження.",
        "option-eeb-description-v2": "Ми самі запитаємо підтвердження у вашої каси. Для цього потрібна ваша згода.",
        "call-instruction": "Зателефонуйте до лікарняної каси й попросіть надіслати підтвердження до нашої практики.",
        "call-instruction-practice": "Зателефонуйте до лікарняної каси й попросіть надіслати підтвердження до практики {{practice}}.",
        "done-button": "Готово – далі",
        "done-button-countdown": "Готово – далі (ще {{seconds}} с)"
      },
      "eeb-consent": {
        "title": "Згода",
        "subtitle": "Нам потрібна ваша згода на електронну перевірку страховки.",
        "insurance": "Ваша страховка",
        "consent-title": "Згода на електронну перевірку страховки (eEB)",
        "consent-text": "Я розумію, що моя медична страхова компанія передасть мої страхові дані (наприклад, ім'я, дату народження, страховий номер) через захищену службу зв'язку KIM до клініки {{practiceName}} як підтвердження страхування. Я погоджуюся на цю передачу. Я знаю, що можу відкликати цю згоду будь-коли без впливу на моє лікування.",
        "withdrawal-notice": "Ви можете відкликати цю згоду в будь-який час.",
        "agree-button": "Я згоден",
        "decline-button": "Скасувати",
        "treatment-notice": "Ваше лікування не залежить від цієї згоди.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Підтвердження від вашої лікарняної каси",
        "summary": "Ваша лікарняна каса надсилає нам підтвердження напряму. Для цього потрібна ваша згода.",
        "confirm-first": "Спочатку підтвердьте заяву."
      },
      "qr-code": {
        "title": "Відскануйте додатком страхової компанії",
        "instruction-1": "Відкрийте додаток вашої страхової компанії і відскануйте цей QR-код.",
        "instruction-2": "Після цього клініка автоматично отримає підтвердження вашого страхування.",
        "practice": "Клініка: {{name}}",
        "alternative-hint": "Альтернатива: використовуйте додаток страхової компанії",
        "instruction-app": "Відкрийте застосунок своєї лікарняної каси та відскануйте цей код. Підтвердження надійде прямо до нас.",
        "staff-line": "Для команди практики: {{address}}",
        "staff-line-practice": "Для команди практики: {{name}} · {{address}}",
        "alternative-app": "Підтвердження можна запросити й через застосунок каси: відкрийте застосунок і відскануйте цей код."
      },
      "register-basics": {
        "title": "Особиста інформація",
        "subtitle": "Будь ласка, введіть ваші дані.",
        "family-name": "Прізвище",
        "given-name": "Ім'я",
        "dob": "Дата народження",
        "gender": "Стать",
        "insurance-type": "Тип страховки",
        "insurer-name": "Назва вашої страховки",
        "insurer-name-placeholder": "напр. Debeka, DKV, Allianz...",
        "gender-required": "Оберіть один варіант."
      },
      "register-insurer": {
        "title": "Медична страховка",
        "subtitle": "Будь ласка, виберіть вашу медичну страховку.",
        "search-placeholder": "Пошук страховки..."
      },
      "register-details": {
        "title": "Зведення",
        "subtitle": "Будь ласка, перевірте вашу інформацію.",
        "create": "Завершити реєстрацію",
        "missing-data": "Будь ласка, заповніть усі необхідні поля.",
        "create-error": "Помилка реєстрації. Спробуйте ще раз.",
        "policy-number": "Номер полісу (необов'язково)",
        "policy-number-placeholder": "Номер вашого полісу",
        "create-v2": "Завершити реєстрацію",
        "policy-number-hint": "Номер указано на картці вашого страхування."
      },
      "diff-review": {
        "eyebrow-chip": "Огляд",
        "eyebrow": "Реєстрація · дані картки",
        "title": "Порівняння даних",
        "subtitle": "Виявлено відмінності між даними вашої картки та нашими записами.",
        "col-current": "Поточний запис",
        "col-new": "Нове з картки",
        "new-badge": "новий",
        "field-fallback": "Поле",
        "note": "Оновлені дані допомагають нам правильно виставляти рахунок і зв’язуватися з вами в екстрених випадках.",
        "comparison-placeholder": "Порівняння буде показано тут",
        "confirm": "Підтвердити зміни",
        "apply-error": "Не вдалося застосувати дані. Спробуйте ще раз.",
        "retry": "Спробуйте ще раз",
        "skip": "Все одно продовжити",
        "no-changes": "Зміни не знайдено",
        "title-v2": "Ваші дані змінилися",
        "subtitle-v2": "На вашій картці новіші дані. Прийняти їх?",
        "confirm-v2": "Прийняти й зареєструватися",
        "keep": "Зареєструватися без змін",
        "col-current-v2": "Раніше",
        "col-new-v2": "Нове з картки",
        "value-yes": "Так",
        "value-no": "Ні"
      },
      "insurance-selection": {
        "title": "Тип страховки",
        "subtitle": "Будь ласка, виберіть тип вашої страховки.",
        "gkv": "Державна страховка",
        "gkv-description": "Член державної медичної страховки.",
        "pkv": "Приватна або самооплата",
        "pkv-description": "Приватна страховка або самооплата.",
        "pkv-description-v2": "Приватне медичне страхування, або ви платите самі."
      },
      "eeb-request": {
        "title": "Запит зареєстровано",
        "subtitle": "Ви можете завершити реєстрацію. Відповідь від {{insurer}} надійде до практики пізніше.",
        "verifying": "Ваш запит прийнято до негайного опрацювання.",
        "success": "Ваш запит безпечно передано команді практики.",
        "error": "Підтвердження запиту недоступне.",
        "try-alternative": "Альтернативний метод",
        "kim-load-error": "Не вдалося завантажити KIM-адресу клініки.",
        "kim-label": "Клініка · KIM",
        "non-blocking-note": "Це ще не підтверджує отримання вашою лікарняною касою або ваш страховий статус.",
        "auto-continue": "Автоматичний перехід через {{seconds}} секунд.",
        "unavailable-title": "На жаль, не вдалося",
        "unavailable-v2": "Не вдалося зареєструвати ваш запит до лікарняної каси.",
        "unavailable-body": "Ви можете запросити підтвердження через застосунок каси або вирішити питання на рецепції.",
        "use-app": "Через застосунок",
        "at-reception": "Вирішити на рецепції"
      },
      "self-pay": {
        "title": "Самооплата",
        "subtitle": "Ви будете лікуватися як пацієнт з самооплатою.",
        "info": "Будь ласка, зверніть увагу, що ви будете нести відповідальність за витрати на лікування.",
        "confirm": "Зрозуміло",
        "title-v2": "Ви платите самі",
        "subtitle-v2": "Ви оплачуєте лікування самі.",
        "insured-after-all": "Усе ж застрахований"
      },
      "done": {
        "title": "Готово!",
        "subtitle": "Ваша реєстрація завершена.",
        "finish": "Завершити",
        "done-label": "Виконано",
        "error-label": "Примітка",
        "eyebrow": "Заїзд · завершено",
        "queue-label": "Зал очікування",
        "queue-title": "Будь ласка, сідайте",
        "queue-meta": "Ми передзвонимо вам особисто.",
        "success-title": "Реєстрація успішна!",
        "success-subtitle": "Будь ласка, займіть місце в залі очікування. Вас викличуть.",
        "auto-redirect": "Ви будете перенаправлені на початкову сторінку найближчим часом...",
        "auto-redirect-countdown": "Повернення до початку через {{seconds}} секунд...",
        "card-expired-title": "Картка прострочена",
        "card-expired-subtitle": "Ваша страхова картка прострочена.",
        "card-expired-info": "Будь ласка, зверніться до персоналу за допомогою.",
        "back-to-start": "Повернутися до початку",
        "anamnesis-title": "Повна форма історії хвороби",
        "anamnesis-description": "Відскануйте QR code, щоб зручно заповнити форму історії хвороби на своєму смартфоні.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Ви зареєстровані",
        "card-expired-info-v2": "Зверніться на рецепцію."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Перевірте свої дані",
          "balance-prefix": "Під час збереження:",
          "balance-direct-v2": "Збережено одразу: {{count}}",
          "balance-reception-v2": "Перевірить рецепція: {{count}}",
          "chip-reception-v2": "Зміни перевіряє наша рецепція",
          "chip-changed": "Змінено: {{count}}",
          "remove": "Видалити",
          "example-email": "напр. imya@pryklad.ua",
          "example-phone": "напр. 0171 1234567",
          "intro-v2": "Вашу реєстрацію завершено. Ці дані ще правильні? Перевірка добровільна.",
          "auto-hide": "Показані значення через короткий час знову приховуються."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Ми передали ці дані на рецепцію.",
          "banner-done-v2": "Дякуємо! Ми отримали ваші дані.",
          "footer-v2": "Усі інші дані залишаються без змін."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "З міркувань захисту даних ми закрили показ. Вашу реєстрацію все одно завершено. Про зміни можна будь-коли повідомити на рецепції."
        }
      },
      "progress": {
        "identify": "Реєстрація",
        "insurance": "Страхування",
        "done": "Готово"
      },
      "dob-format-hint": "Наприклад 01.10.1980",
      "dob-required": "Введіть дату народження.",
      "insurance-label": {
        "GKV": "Обов'язкове страхування",
        "PKV": "Приватне страхування",
        "SELFPAY": "Оплата самостійно"
      }
    },
    "emergency": {
      "title": "Гостра надзвичайна ситуація!",
      "label": "Надзвичайна ситуація",
      "subtitle": "Цей сигнал чутно лише на місці, і він не викликав допомогу. У разі гострої або потенційно небезпечної для життя ситуації телефонуйте 112.",
      "call-emergency": "Виклик служби екстреної допомоги (112)",
      "stop-sound": "Зупинити звук",
      "play-sound": "Відтворення звуку",
      "back-to-start": "Повернутися до початку",
      "headline": "Негайно зверніться до персоналу на рецепції. У разі загрози життю телефонуйте 112."
    },
    "help-reception": "Довідка з прийому",
    "help-reception-toast": "Будь ласка, зв'яжіться з адміністрацією. Ми раді допомогти.",
    "language-entry": {
      "title": "Оберіть мову"
    },
    "loading": "Завантаження…",
    "step-progress-label": "Перебіг",
    "step-progress-phase": "Розділ {{current}} з {{total}}: {{phase}}",
    "step-progress-substep": "Частина {{current}} з {{total}}",
    "step-progress-complete": "Завершено",
    "identification": {
      "title": "Хто ви?",
      "lead": "Найшвидше — з вашою медичною страховою карткою. Можна також шукати за іменем.",
      "lead-card-only": "Будь ласка, вставте медичну страхову картку в зчитувач карток.",
      "mode-label": "Як ви хочете зареєструватися?",
      "mode-card": "Карткою",
      "mode-search": "Пошук за іменем",
      "mode-create": "Уперше в практиці",
      "card": {
        "loading": "Підготовка зчитувача карток …",
        "checking": "Перевірка зчитувача карток …",
        "insert-title": "Будь ласка, вставте медичну страхову картку в зчитувач карток.",
        "insert-detail": "Ми зчитуємо ваші дані автоматично.",
        "detected": "Картку розпізнано",
        "read": "Зчитати картку",
        "reading": "Картка зчитується …",
        "reading-hint": "Будь ласка, не виймайте картку.",
        "no-terminal-title": "Зчитувач карток недоступний",
        "help-with-search": "Будь ласка, знайдіть себе за іменем або запитайте на рецепції.",
        "help-reception": "Будь ласка, зверніться на рецепцію — ми охоче допоможемо.",
        "unreadable-title": "Картку розпізнано, але її не вдається прочитати",
        "error-title": "Не вдалося зчитати картку",
        "not-unique": "Не вдалося однозначно зіставити вас із цією карткою. Будь ласка, знайдіть себе за іменем або запитайте на рецепції.",
        "no-match": "За цією карткою даних не знайдено. Будь ласка, знайдіть себе за іменем або запитайте на рецепції.",
        "without-card": "Продовжити без картки"
      },
      "lookup": {
        "lead": "Будь ласка, введіть прізвище та дату народження.",
        "first-name": "Ім'я",
        "last-name": "Прізвище",
        "dob": "Дата народження",
        "dob-hint": "Формат: ДД.ММ.РРРР",
        "search": "Шукати",
        "confirm": "Так, це я",
        "found-title": "Ми вас знайшли",
        "found-body": "Будь ласка, підтвердьте, що це ви.",
        "first-name-needed-title": "Будь ласка, додайте своє ім'я",
        "first-name-needed-body": "Щоб ми знайшли вас однозначно. Потім натисніть «Шукати».",
        "ambiguous-title": "Не вдалося однозначно вас знайти",
        "ambiguous-body": "Будь ласка, зверніться на рецепцію — ми охоче допоможемо.",
        "not-found-title": "Відповідних даних не знайдено",
        "not-found-body": "Будь ласка, перевірте введені дані.",
        "error-title": "Пошук зараз неможливий",
        "error-body": "Будь ласка, спробуйте ще раз або запитайте на рецепції."
      },
      "create": {
        "insurance-question": "Як ви застраховані?",
        "insurance-required": "Будь ласка, виберіть вид страхування.",
        "error-title": "Не вдалося зберегти ваші дані",
        "error-body": "Будь ласка, спробуйте ще раз або запитайте на рецепції."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Спочатку розблокуйте",
      "subtitle": "FrontDesk+ має бути активовано у вашому навчальному програмному забезпеченні.",
      "step1": "Замовляйте в SolStore (або ваш партнер Doc-Cirrus замовляє для вас).",
      "step2": "Після активації активуйте в inSuite під «inSuite Sols» (права адміністратора).",
      "step3": "Відкрийте адміністрування Bridge → «Додати пристрій».",
      "cta": "Все зроблено - вперед"
    },
    "welcome": {
      "title": "Додайте цей пристрій до практики",
      "scan": "Сфотографуйте код",
      "prepare-link": "Немає коду в inSuite?",
      "language": "Мова"
    },
    "scan": {
      "requesting": "Потрібен доступ до камери…",
      "scanning": "Наведіть камеру на код",
      "paste": "Натомість вставте",
      "manual-title": "Підключити вручну",
      "manual-description": "Якщо QR-код недоступний, візьміть дані підключення в адміністрації Bridge.",
      "address-label": "Адреса Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Вставте SOLTOKEN",
      "manual-submit": "Взяти підключення",
      "error-title": "Код не розпізнано",
      "camera-denied-title": "Доступ до камери заборонено",
      "camera-denied-hint": "Надайте доступ до камери в налаштуваннях і повторіть спробу.",
      "retry": "Спробуйте знову"
    },
    "preflight": {
      "title": "Буде налаштовано",
      "all-green": "Всі тести пройдені",
      "practice": "Практика",
      "device-name": "Назва пристрою",
      "device-name-placeholder": "напр. B. Прийом 1",
      "card-reader": "Зчитувач карток",
      "pin": "Новий секретний номер",
      "pin-placeholder": "Чотиризначний PIN-код",
      "finish": "Закінчити",
      "recheck": "Перевірте ще раз",
      "diagnosis": "ID діагнозу",
      "checklist-error": "Bridge відхилив з'єднання або недоступний. Перевірте SOLTOKEN і адресу Bridge.",
      "checklist-retry": "Перевірити ще раз",
      "edit-token": "Змінити SOLTOKEN",
      "rescan": "Сканувати код ще раз"
    },
    "persisting": "Збереження налаштувань …",
    "success": {
      "title": "Пристрій додано",
      "detail": "Пристрій тільки що з'явився на практиці ПК.",
      "starting": "Запускається режим пацієнта…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Підключення до навчального програмного забезпечення",
        "fix": "Bridge Перевірте підключення та адресу сервера."
      },
      "missing_insuite_url": {
        "label": "Адреса inSuite",
        "fix": "Відскануйте QR-код ще раз - адреса відсутня."
      },
      "missing_server_token": {
        "label": "Маркер сервера",
        "fix": "Відскануйте QR-код ще раз - маркер відсутній."
      },
      "missing_gateway_session": {
        "label": "Сеанс Gateway",
        "fix": "Увійдіть знову — сесія відсутня."
      },
      "missing_gateway_enrollment": {
        "label": "Реєстрація пристрою",
        "fix": "Зареєструйте пристрій на Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway готовність",
        "fix": "Зачекайте, поки Gateway завершить налаштування."
      },
      "token_verification_failed": {
        "label": "Перевірка жетонів",
        "fix": "Перевірте маркер сервера або підключення Bridge."
      },
      "session_expired": {
        "label": "засідання",
        "fix": "Сеанс закінчився - увійдіть знову."
      },
      "device_revoked": {
        "label": "Статус пристрою",
        "fix": "Цей пристрій заблоковано. Зверніться до практики."
      },
      "missing_practice_name": {
        "label": "Назва практики",
        "fix": "Не вдалося завантажити назву медичної практики (inSuite)."
      },
      "missing_device_name": {
        "label": "Назва пристрою",
        "fix": "Введіть назву пристрою."
      },
      "telematik_unavailable": {
        "label": "Телематична інфраструктура",
        "fix": "Необов’язково — перевірка картки залишається можливою, щойно TI стане доступним."
      },
      "selected_card_reader_unavailable": {
        "label": "Зчитувач карток",
        "fix": "Додатково — виберіть або підключіть кардрідер."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "За бажанням — вставте облікову картку медичної практики (SMC-B)."
      }
    },
    "token": {
      "title": "Введіть SOLTOKEN",
      "description": "З міркувань безпеки QR-код не містить SOLTOKEN. Скопіюйте його в inSuite у розділі «Sol-Aktivierung» (FrontDesk+) і вставте сюди.",
      "submit": "Далі",
      "rescan": "Сканувати код ще раз"
    }
  }
}
